<template>
    <section class="modal-container" @click.self="$emit('close')">
        <div class="modal" :class="modalSize">
            <svg
                data-test-id="modal_button_close"
                @click="$emit('close')"
                class="close_icon"
                width="10.707"
                height="10.707">
                <use :href="require('@/assets/img/close_modal.svg') + '#icon'"></use>
            </svg>
            <slot></slot>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        modalSize: {
            type: String,
            required: false
        }
    }
}
</script>
